import React, { useState } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/material components
import { makeStyles, createStyles } from '@mui/styles';
import { Input, Box, Zoom, IconButton, InputLabel, FormControl, FormHelperText, InputAdornment } from '@mui/material';

import CheckIcon from  '@mui/icons-material/Check';
import Visibility from  '@mui/icons-material/Visibility';
import VisibilityOff from  '@mui/icons-material/VisibilityOff';


import styles from "assets/jss/components/customInputStyle.js";

const useStyles = makeStyles(createStyles(styles));

const FormCreativeTextField = (
    { input: { onDragStart, onDrop, ...input }, meta: { asyncValidating, touched, dirty, error, warning, valid, ...custom }, ...props }
) => {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  let inputProps;
  const {
    dragable,
    formControlProps,
    label,
    id,
    labelProps,
    white,
    inputRootCustomClasses,
    helperText,
    type,
    endAdornment,
    disableCheck,
    ...rest
  } = props;

  const handleClickShowPassword = () => setShowPassword(prev => !prev);

  const handleMouseDownPassword = (event) => event.preventDefault();

  const showError = dirty && error;
  const success = valid && dirty && !showError ? true : false;

  const labelClasses = classNames({
    [" " + classes.labelRootError]: showError,
    [" " + classes.labelRootSuccess]: success && !showError
  });
  const underlineClasses = classNames({
    [classes.underlineError]: showError,
    [classes.underlineSuccess]: success && !showError,
    [classes.underline]: true,
    [classes.whiteUnderline]: white
  });
  const marginTop = classNames({
    [inputRootCustomClasses]: inputRootCustomClasses !== undefined
  });
  const inputClasses = classNames({
    [classes.input]: true,
    [classes.whiteInput]: white
  });
  var formControlClasses;
  if (formControlProps !== undefined) {
    formControlClasses = classNames(
      formControlProps.className,
      classes.formControl
    );
  } else {
    formControlClasses = classes.formControl;
  }
  var helpTextClasses = classNames({
    [classes.labelRootError]: error,
    [classes.labelRootSuccess]: success && !showError
  });

  return (
    <FormControl {...formControlProps} className={formControlClasses}>
      {
        label && <InputLabel
          className={classes.labelRoot + " " + labelClasses}
          htmlFor={id}
          {...labelProps}
        >
          {label}
        </InputLabel>
      }
      <Input
        classes={{
          input: inputClasses,
          root: marginTop,
          disabled: classes.disabled,
          underline: underlineClasses
        }}
        id={id}
        onDragStart={dragable ? onDragStart : null}
        onDrop={dragable ? onDrop : null}
        type={showPassword ? 'text' : 'password'}
        {...input}
        {...rest}
        endAdornment={
          <Box display="flex">
            {
              !disableCheck && valid && dirty &&
                <Zoom in>
                  <InputAdornment position='start'>
                    <CheckIcon className={classes.labelRootSuccess} />
                  </InputAdornment>
                </Zoom>
            }
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          </Box>
        }
      />
      {
        <FormHelperText id={id + "-text"} className={helpTextClasses}>
          { helperText && (!warning && !error) && <span>{helperText}</span>}
          { touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
        </FormHelperText>
      }
    </FormControl>
  );
}

FormCreativeTextField.defaultProps = {
  id: 'FormCreativeTextField',
  dragable: false,
  disableCheck: false,
};

FormCreativeTextField.propTypes = {
  label: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  white: PropTypes.bool,
  helperText: PropTypes.node
};

export default FormCreativeTextField;
